import _export from '../internals/export.js';
import stringTrim from '../internals/string-trim.js';
import stringTrimForced from '../internals/string-trim-forced.js';

var $ = _export;
var $trimStart = stringTrim.start;
var forcedStringTrimMethod = stringTrimForced;
var FORCED = forcedStringTrimMethod('trimStart');
var trimStart = FORCED ? function trimStart() {
  return $trimStart(this); // eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart; // `String.prototype.{ trimStart, trimLeft }` methods
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft

$({
  target: 'String',
  proto: true,
  name: 'trimStart',
  forced: FORCED
}, {
  trimStart: trimStart,
  trimLeft: trimStart
});
